import styled from 'styled-components'

export const ModalFooter = styled.footer`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  gap: 25px;

  .clearFiltersButton {
    display: flex;
    align-items: center;
    gap: 5px;
  
    &:disabled {
      cursor: not-allowed;
      color: #C1C1C1;
    }
  }

  .applyFiltersButton {
    width: 185px;
  }

  @media (max-width: 420px) {
    padding: 20px 30px;
    gap: 15px;

    .clearFiltersButton {
      gap: 0;
      flex: 1;
      padding: 0;
    }

    .applyFiltersButton {
      width: 162px;
      height: 48px;
      font-weight: bold;
      flex: 1;
    }
  }
`